import {createRouter, createWebHistory} from 'vue-router'
import Home from '../views/Home.vue'
import store from "../store";


const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        children: [
            {
                path: '/index',
                name: 'index',
                component: () => import("@/views/tabbar/index")
            },
            {
                path: '/plan',
                name: 'plan',
                component: () => import("@/views/tabbar/plan")
            },
            {
                path: '/mailbox',
                name: 'mailbox',
                component: () => import("@/views/tabbar/mailbox")
            },
            {
                path: '/managerManage',
                name: 'managerManage',
                component: () => import("@/views/tabbar/manager.vue")
            }
        ]
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    // {
    //     path: '/write',
    //     name: 'write',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/WriteSms.vue')
    // },
    {
        path: '/write',
        name: 'write2',
        component: () => import(/* webpackChunkName: "about" */ '../views/WriteSmsV2.vue')
    },
    // {
    //     path: '/plan/create',
    //     name: 'Create',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/plan/Create.vue')
    // },
    {
        path: '/plan/create',
        name: 'CreateV3',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/plan/CreateV3.vue')
    },
    {
        path: '/plan/manage',
        name: 'PlanManage',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/plan/Manage.vue')
    },
    {
        path: '/plan/record',
        name: 'Record',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/plan/Record.vue')
    },
    {
        path: '/chat',
        name: 'Chat',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Chat.vue')
    },
    {
        path: '/login',
        name: 'Login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
    },
    {
        path: '/receiver',
        name: 'Receiver',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Receiver.vue')
    },
    {
        path: '/messenger',
        name: 'Receiver',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/messenger/Messenger.vue')
    },
    {
        path: '/messenger/manage',
        name: 'Manage',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/messenger/Manage.vue')
    },
    {
        path: '/msgDetail',
        name: 'MsgDetail',
        component: () => import('@/views/messenger/Detail.vue')
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})
// router.beforeEach((to, from, next) => {
//     if (store.getters.get_token || to.path !== '/login') {  // 通过vuex state获取当前的token是否存在
//         next();
//     } else {
//         next({
//             path: '/login',
//             query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
//         })
//     }
// })

export default router
